import React, { Component } from 'react';
import ProjectsLayout from '../../templates/project';
import ExpensesTable from '../../elements/project/expenses';

class ProjectExpenses extends Component {
	render (){
		const {project, concepts} = this.props;
		return (
			<ExpensesTable
				expenses={project.expenses}
				concepts={concepts}
				permissions={project.permissions}
				match={this.props.match}
				add={this.props.add}
				change={this.props.change}
				remove={this.props.remove}
				history={this.props.history}
				setSystemNotification={this.props.setSystemNotification}
				projectExpensesSave={this.props.projectExpensesSave}
			/>
		)
	}

	componentWillMount() {
		let { modality, state, municipality } = this.props.match.params;
		this.props.projectExpenses(modality, state, municipality);
	}

    componentWillReceiveProps(newprops) {
	    let { modality, state, municipality } = newprops.match.params;
	    if(newprops.location.pathname !== this.props.location.pathname) {
		    this.props.projectExpenses(modality, state, municipality);
	    }
    }
}

export default ProjectsLayout(ProjectExpenses, {subnav: 4});



// WEBPACK FOOTER //
// ./src/layouts/project/expenses.jsx